export const contacts = [
    {
        name: "Email",
        url: "mailto:moremintteas@gmail.com",
    },
    {
        name: "Github",
        url: "https://github.com/moreminttea",
    },
    {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/mindymohr/",
    },
    {
        name: "Resume",
        url: '/UIUX_Designer_&_Frontend_Engineer.pdf',
    },
]

export const skills = [
    'React.js',
    'Typescript',
    'HTML/SCSS',
    'WCAG',
    'UI/UX Design',
    'Figma',
    'Wireframing',
    'Prototyping',
    'Responsive Web Design',
    'Git / CICD',
    'Jest',
    'Design-to-Code (Claude AI-Assisted)'
]